export enum MessageChannel {
	WHATSAPP = 'whatsapp',
	SMS = 'sms',
	CALL = 'call',
}
